import { render, staticRenderFns } from "./ItemHistoryChangeTypeCustomStatus.vue?vue&type=template&id=4d3ba821&scoped=true"
import script from "./ItemHistoryChangeTypeCustomStatus.vue?vue&type=script&lang=js"
export * from "./ItemHistoryChangeTypeCustomStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ba821",
  null
  
)

export default component.exports